module.exports = __webpack_public_path__ + "img/equ-bigger.a634b8aa.png";